import React from 'react';
import ProductAnswer from 'modules/product/views/components/product-questions-answers/components/product-answer';
import { QuestionsAndAnswersItemInterface } from 'modules/product/views/components/product-questions-answers/interfaces/questions-and-answers-item.interface';

import './product-answers.scss';

interface ProductAnswersProps {
    answers: QuestionsAndAnswersItemInterface[];
    offerLink?: string;
}

const ProductAnswers: React.FC<ProductAnswersProps> = ({ answers, offerLink }) => {
    return (
        <ul className="answers">
            {answers.map(answer => (
                <li className="answers__item" key={answer.id}>
                    <ProductAnswer
                        offerLink={offerLink}
                        createdAt={answer.createdAt}
                        text={answer.text}
                        author={answer.author}
                    />
                </li>
            ))}
        </ul>
    );
};

export default ProductAnswers;
